var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('h2',[_vm._v("Upcoming Trails:")]),_c('EventList')],1)],1),_c('b-row',[_c('b-col',[_c('HomePageBlurb')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }